<template>
  <div class="top-container">
    <div class="back-home" @click="goHome">返回首页</div>
    <div class="top-center">
      综合管理平台<span style="font-size: 14px; margin-left: 5px"
        >({{ currentDomain }})</span
      >
    </div>
    <div class="top-right">
      <div
        class="domain-selector"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <p>更换节点</p>
        <div
          class="dropdown-toggle"
          :class="{ rotated: showDomainDropdown }"
        ></div>
        <div
          v-if="showDomainDropdown"
          class="domain-dropdown"
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
        >
          <div
            v-for="domain in domainList"
            :key="domain.serverName"
            class="domain-option"
            :class="{ active: currentDomain === domain.serverName }"
            @click="handleDomainChange(domain.serverHost)"
          >
            {{ domain.serverName }}
          </div>
        </div>
      </div>
      <span class="username">当前用户：{{ username }}</span>
      <el-button
        type="text"
        class="logout-btn"
        :loading="loading"
        @click="handleLogout"
        >退出</el-button
      >
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { loginApi } from "../api/login";

export default {
  name: "TopBar",
  inject: ["removeToken"],
  data() {
    return {
      username: "",
      loading: false,
      showDomainDropdown: false,
      domainList: [],
      currentDomain: "",
      dropdownTimeout: null,
    };
  },
  mounted() {
    // 获取用户名
    this.username = this.getCookie("username") || "";
    // 获取当前域名（移除端口号）
    // const origin = window.location.origin
    // this.currentDomain = origin.replace(/:\d+$/, '')
    this.getCurrentDomain();
    this.getDomainList();
  },
  methods: {
    // 获取节点列表
    getDomainList() {
      let token = this.getCookie("token") || "";
      loginApi.getDomainList(token).then((response) => {
        console.log(response, "fdsjifdjisfjisdjfisd");
        this.domainList = response.data || [];
      });
    },
    // 获取当前节点·
    getCurrentDomain() {
      loginApi.getCurrentDomain().then((response) => {
        console.log(response, "fdsjifdjisfjisdjfisd");
        this.currentDomain = response.data.serverName || "";
      });
    },

    // 获取Cookie
    getCookie(name) {
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`));
      return cookieValue ? cookieValue.split("=")[1] : null;
    },
    goHome() {
      this.$router.push("/");
    },
    handleLogout() {
      this.loading = true;
      // 获取当前 token
      const token = this.getCookie("token");

      // 调用退出登录 API
      loginApi
        .logout(token)
        .then((response) => {
          console.log("退出登录成功:", response);
          if (response.code === 200) {
            ElMessage.success("退出登录成功");
          } else {
            console.error("退出登录失败:", response.msg || "未知错误");
          }
        })
        .catch((error) => {
          console.error("退出登录错误:", error);
          // 即使 API 调用失败，也要清除本地状态
        })
        .finally(() => {
          // 无论 API 调用是否成功，都需要清除本地的 token 和用户名
          this.removeToken();
          // 移除用户名
          const expires = new Date();
          expires.setTime(expires.getTime() - 1);
          document.cookie = `username=;expires=${expires.toUTCString()};path=/`;
          console.log("退出登录，Token和用户名已清除");
          // 跳转到登录页面
          this.$router.push("/login");
          this.loading = false;
        });
    },
    handleDomainChange(serverHost) {
      // 重定向到选择的域名
      window.location.href = 'http://' + serverHost + window.location.pathname + window.location.search;
    },
    handleMouseEnter() {
      // 清除延迟隐藏的定时器
      clearTimeout(this.dropdownTimeout);
      // 显示下拉框
      this.showDomainDropdown = true;
    },
    handleMouseLeave() {
      // 设置延迟隐藏的定时器
      this.dropdownTimeout = setTimeout(() => {
        this.showDomainDropdown = false;
      }, 200);
    },
  },
};
</script>

<style scoped lang="less">
.top-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #fff;
  z-index: 1000;
  width: 100%;
  // padding: 0 20px;
  padding-right: 20px;
  background-color: #0785dc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
}

.back-home {
  cursor: pointer;
  color: #ffffff;
  font-size: 14px;
  padding: 5px 10px;
  margin-left: 20px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.back-home:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.top-center {
  flex: 1;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #ffffff;
  line-height: 60px;
}

.top-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 40px;
  display: flex;
  align-items: center;
  gap: 20px;
}
.logout-btn {
  color: #ffc400;
}
.logout-btn:hover {
  color: aliceblue !important;
}

.username {
  color: aliceblue;
  font-size: 14px;
}

.domain-selector {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.domain-selector p {
  color: aliceblue;
  font-size: 14px;
  margin: 0;
  margin-right: 5px;
}

.dropdown-toggle {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid aliceblue;
  transition: transform 0.3s;
  margin-left: 5px;
}

.dropdown-toggle.rotated {
  transform: rotate(180deg);
}

.domain-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 5px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 120px;
}

.domain-option {
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

.domain-option:hover {
  background-color: #f5f7fa;
}

.domain-option.active {
  background-color: #e6f7ff;
  color: #1890ff;
}
</style>